<section class="d-flex mt-2 justify-content-between">
    <section class="btn-toolbar">
        <app-statistik-options-periode class="d-flex" [periode]="periode" (periodeChange)="onPeriodeChange($event)"></app-statistik-options-periode>
        <app-statistik-options-grupper class="d-flex" (selectGruppe)="onSelectGruppe($event)"></app-statistik-options-grupper>
    </section>
    <section class="btn-toolbar me-2">
        <app-statistik-options-formler></app-statistik-options-formler>
        <div class="ms-2" *ngIf="listOfFormels$ | async as listOfFormels">
            <button (click)="onExport(listOfFormels)" class="btn btn--menu btn-primary btn-sm" type="submit">Eksport</button>
        </div>
    </section>
</section>

<section class="table__viewport">
    <table class="table table-hover table-striped table-sm table-frame__body">
        <thead class="fixed-top position-fixed position-sticky">
        <tr>
            <th (click)="toggleAfdelinger()">Afdeling</th>
            <th> Init </th>
            <th class="text-end"> Normtid <br> (A)</th>
            <th class="text-end"> Plan tid kunder <br> (hele måneder) (B) </th>
            <th class="text-end"> Total <br> (C) </th>
            <th class="text-end"> Fakturerbar <br> (D) </th>
            <th class="text-end"> Intern Produktiv <br> (E) </th>
            <th class="text-end"> Intern Uproduktiv <br> (F) </th>
            <th class="text-end"> Sygdom mv <br> (G) </th>
            <th class="text-end"> Ferie <br> (H) </th>
            <th class="text-end"> Omregnet Overtid <br> (I) </th>
            <th class="text-end"> Udbetalt Overtid <br> (J) </th>

            <th class="text-end" *ngFor="let formel of listOfFormels$ | async; trackBy: trackFormelId;">{{formel.betegnelse}}</th>
        </tr>
        </thead>

        <tbody>
        <ng-container *ngFor="let afdeling of afdelinger; trackBy: trackAfdelingNavn">
            <ng-container *ngFor="let medarbejder of afdeling.medarbejdere; trackBy: trackMedarbejderInit">
                <tr class="item__tr" *ngIf="isMedarbejderVisible(medarbejder)">
                    <td>{{medarbejder.afdeling}}</td>
                    <td>{{medarbejder.init}}</td>
                    <td class="text-end">{{medarbejder.normtid | time}}</td>
                    <td class="text-end" (click)="openPlantidModal(medarbejder)" [ngClass]="{'link-td': medarbejder.plan_tid_kunder !== 0}">{{medarbejder.plan_tid_kunder | time}}</td>
                    <td class="text-end">{{medarbejder.total | time}}</td>
                    <td class="text-end">{{medarbejder.fakturebar | time}}</td>
                    <td class="text-end" (click)="openEmployeeTimeLogModal(medarbejder, 2)" [ngClass]="{'link-td': medarbejder.intern_produktiv !== 0}">{{medarbejder.intern_produktiv | time}}</td>
                    <td class="text-end" (click)="openEmployeeTimeLogModal(medarbejder, 3)" [ngClass]="{'link-td': medarbejder.intern_uproduktiv !== 0}">{{medarbejder.intern_uproduktiv | time}}</td>
                    <td class="text-end" (click)="openEmployeeTimeLogModal(medarbejder, 4)" [ngClass]="{'link-td': medarbejder.sygdom !== 0}">{{medarbejder.sygdom | time}}</td>
                    <td class="text-end" (click)="openEmployeeTimeLogModal(medarbejder, 5)" [ngClass]="{'link-td': medarbejder.ferie !== 0}">{{medarbejder.ferie | time}}</td>
                    <td class="text-end" (click)="openEmployeeTimeLogModal(medarbejder, 6)" [ngClass]="{'link-td': medarbejder.omregnet_overtid !== 0}">{{medarbejder.omregnet_overtid | time}}</td>
                    <td class="text-end" (click)="openEmployeeTimeLogModal(medarbejder, 7)" [ngClass]="{'link-td': medarbejder.udbetalt_overtid !== 0}">{{medarbejder.udbetalt_overtid | time}}</td>

                    <td class="text-end" *ngFor="let formel of listOfFormels$ | async; trackBy: trackFormelId;"
                        [ngClass]="calcFormula(medarbejder, formel.formel).valid ? 'text-dark' : 'text-danger'">
                        <ng-container *ngIf="calcFormula(medarbejder, formel.formel).valid; else textResult">
                            {{calcFormula(medarbejder, formel.formel).result | time }}
                        </ng-container>
                        <ng-template #textResult>
                            <p>Formlen fejler</p>
                        </ng-template>
                    </td>

                </tr>

            </ng-container>

            <tr *ngIf="afdelinger.length > 1 && isAfdelingVisible(afdeling)" (click)="toggleAfdeling(afdeling.afdelingNavn)" class="total__tr">
                        <th><i [ngClass]="expandedAfdelinger.includes(afdeling.afdelingNavn) ? 'fa fa-caret-up' : 'fa fa-caret-right'"></i>Total {{afdeling.afdelingNavn || '(Ikke angivet)'}}</th>
                        <th></th>
                        <th class="text-end">{{afdeling.medarbejdere | totalFromProperty:'normtid' | time}}</th>
                        <th class="text-end">{{afdeling.medarbejdere | totalFromProperty:'plan_tid_kunder' | time}}</th>
                        <th class="text-end">{{afdeling.medarbejdere | totalFromProperty:'total' | time}}</th>
                        <th class="text-end">{{afdeling.medarbejdere | totalFromProperty:'fakturebar' | time}}</th>
                        <th class="text-end">{{afdeling.medarbejdere | totalFromProperty:'intern_produktiv' | time}}</th>
                        <th class="text-end">{{afdeling.medarbejdere | totalFromProperty:'intern_uproduktiv' | time}}</th>
                        <th class="text-end">{{afdeling.medarbejdere | totalFromProperty:'sygdom' | time}}</th>
                        <th class="text-end">{{afdeling.medarbejdere | totalFromProperty:'ferie' | time}}</th>
                        <th class="text-end">{{afdeling.medarbejdere | totalFromProperty:'omregnet_overtid' | time}}</th>
                        <th class="text-end">{{afdeling.medarbejdere | totalFromProperty:'udbetalt_overtid' | time}}</th>

                        <th class="text-end" *ngFor="let formel of listOfFormels$ | async; trackBy: trackFormelId;" [ngClass]="CalcFormulaTotals(afdeling.medarbejdere, formel.formel).valid ? 'text-dark' : 'text-danger'">
                            <ng-container *ngIf="CalcFormulaTotals(afdeling.medarbejdere, formel.formel).valid; else textResult">
                                {{CalcFormulaTotals(afdeling.medarbejdere, formel.formel).result | time }}
                            </ng-container>
                            <ng-template #textResult>
                                <p>Hele formlen fejler</p>
                            </ng-template>
                        </th>
            </tr>
        </ng-container>
        </tbody>

        <tfoot class="fixed-bottom position-fixed position-sticky">
        <tr>
            <th></th>
            <th>Total</th>
            <th class="text-end">{{alleMedarbejdere | totalFromProperty: 'normtid' | time}}</th>
            <th class="text-end">{{alleMedarbejdere | totalFromProperty: 'plan_tid_kunder' | time}}</th>
            <th class="text-end">{{alleMedarbejdere | totalFromProperty: 'total' | time}}</th>
            <th class="text-end">{{alleMedarbejdere | totalFromProperty: 'fakturebar' | time}}</th>
            <th class="text-end">{{alleMedarbejdere | totalFromProperty: 'intern_produktiv' | time}}</th>
            <th class="text-end">{{alleMedarbejdere | totalFromProperty: 'intern_uproduktiv' | time}}</th>
            <th class="text-end">{{alleMedarbejdere | totalFromProperty: 'sygdom' | time}}</th>
            <th class="text-end">{{alleMedarbejdere | totalFromProperty: 'ferie' | time}}</th>
            <th class="text-end">{{alleMedarbejdere | totalFromProperty: 'omregnet_overtid' | time}}</th>
            <th class="text-end">{{alleMedarbejdere | totalFromProperty: 'udbetalt_overtid' | time}}</th>

            <th class="text-end" *ngFor="let formel of listOfFormels$ | async; trackBy: trackFormelId;">
                <ng-container *ngIf="CalcFormulaTotals(alleMedarbejdere, formel.formel).valid; else textResult">
                    {{CalcFormulaTotals(alleMedarbejdere, formel.formel).result | time }}
                </ng-container>
                <ng-template #textResult>
                    <p>Hele formlen fejler</p>
                </ng-template>
            </th>
        </tr>
        </tfoot>
    </table>
</section>
